import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class announcementPopupComponentservice {
    private ngbModalRef: NgbModalRef;
    data: any;

    constructor(
        private modalService: NgbModal,
        private router: Router,

    ) {
        this.ngbModalRef = null;
    }

    setData(data) {
        this.data = data;
    }

    getData() {
        return this.data;
    }

    open(component: Component, id): Promise<NgbModalRef> {
        return new Promise<NgbModalRef>((resolve, reject) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalRef(component, id);
                resolve(this.ngbModalRef);
            }, 0);
        });
    }

    modalRef(component: Component, id): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.id = id;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.ngbModalRef = null;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.ngbModalRef = null;
        });

        return modalRef;
    }
}
